export const Types = {
  GET_WAREHOUSE_PRODUCT_REQUEST: 'GET_WAREHOUSE_PRODUCT_REQUEST',
  GET_WAREHOUSE_PRODUCT_SUCCESS: 'GET_WAREHOUSE_PRODUCT_SUCCESS'
};

export const getWarehouseProductRequest = (startDate, endDate) => ({
  type: Types.GET_WAREHOUSE_PRODUCT_REQUEST,
  startDate,
  endDate
});

export const getWarehouseProductSuccess = data => ({
  type: Types.GET_WAREHOUSE_PRODUCT_SUCCESS,
  payload: { data }
});
